<script>
import {mapActions} from "vuex";
import Confirm from '../../../components/Confirm'

export default {
  name: "ReportOutputFiles",
  components: {
    Confirm,
  },
  props: {
    section: {
      type: String,
      default: () => null,
    },
    reloadResult: {
      type: Boolean,
      default: () => false,
    },
    deletable: {
      type: Boolean,
      default: () => false,
    },
  },
  watch: {
    reloadResult (value) {
      if (value) {
        this.search()
      }
    }
  },
  created () {
    this.search()
  },
  data () {
    return {
      page: 1,
      totalVisible: 7,
      tableHeaders: [
        { text: "受付日時", value: "created_at" },
        { text: "ステータス", value: "status_name" },
        { text: "ファイル名", value: "file_name" },
        { text: "", value: "editable", align: "end" },
      ],
      outputFiles: [],
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {

  },
  methods: {
    ...mapActions("DriverOutputFile", {
      fetchOutputFiles: "index",
      fetchOutputFile: "show",
      deleteOutputFile: "delete",
    }),
    /**
     * 検索処理
     */
    search() {
      this.outputFiles = []
      const conditions = {
        section: this.section,
        page: this.page,
      }
      this.fetchOutputFiles({conditions: conditions}).then((content) => {
        this.outputFiles = content.output_files
        this.pagination = content.pagination
      })
    },
    /**
     * ページ番号 チェンジイベント
     */
    pageChangeEvent () {
      this.search()
    },
    /**
     * 再読み込みボタン クリックイベント
     */
    reloadButtonClickEvent () {
      this.page = 1
      this.search()
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteOutputFile({ id: item.id }).then(() =>{
            this.search()
          })
        }
      })
    },
    /**
     * ダウンロードボタン クリックイベント
     * @param item
     */
    downloadButtonClickEvent (item) {
      this.fetchOutputFile({id: item.id}).then((content) => {
        this.downloadResource(content.url)
      })
    },
    /**
     * ファイルのダウンロード処理
     * @param url
     */
    downloadResource(url) {
      window.open(url, "reportTab");
    }
  },
}
</script>

<template>
  <div>
    <v-row>
      <v-col>
        <v-card class="rounded-card" flat>
          <v-card-title>出力履歴</v-card-title>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="primary"
              @click="reloadButtonClickEvent"
            >
              <v-icon>
                mdi-reload
              </v-icon>
              再読み込み
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="outputFiles"
              :items-per-page="-1"
              disable-sort
              hide-default-footer
            >
              <!-- ダウンロード -->
              <template v-slot:[`item.editable`]="{ item }">
                <v-btn
                  v-if="item.status === 'completed'"
                  small
                  class="info"
                  @click="downloadButtonClickEvent(item)"
                >
                  <v-icon>
                    mdi-file-download
                  </v-icon>
                  ダウンロード
                </v-btn>

                <v-btn
                  v-if="item.deletable"
                  small
                  icon
                  class="ml-2"
                  :color="`error darken-2`"
                  @click="deleteButtonClickEvent(item)"
                >
                  <v-icon>
                    mdi-trash-can-outline
                  </v-icon>
                </v-btn>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="pageChangeEvent"
        />
      </v-col>
    </v-row>
    <confirm ref="confirm" />
  </div>
</template>
